class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Desktop: open on hover and close when the pointer leaves. Touch screens keep tap-to-open.
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    const summary = this.mainDetailsToggle.querySelector('summary');
    this.addEventListener('mouseenter', () => {
      clearTimeout(this.hoverClose);
      if (this.mainDetailsToggle.open) return;
      document.querySelectorAll('header-menu').forEach((menu) => { if (menu !== this) menu.close(); });
      this.mainDetailsToggle.setAttribute('open', '');
      summary.setAttribute('aria-expanded', true);
      this.openedByHover = true;
    });
    // A short delay lets the pointer cross the gap between the menu name and the dropdown
    this.addEventListener('mouseleave', () => {
      this.hoverClose = setTimeout(() => {
        this.close();
        this.openedByHover = false;
      }, 200);
    });
    // Clicking the name of a menu the pointer has already opened keeps it open rather than shutting it
    summary.addEventListener('click', (event) => {
      if (this.openedByHover && this.mainDetailsToggle.open) {
        event.preventDefault();
        this.openedByHover = false;
      }
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
